export const APP_COUNTRIES = process.env.REACT_APP_COUNTRIES
  ? process.env.REACT_APP_COUNTRIES.split(",")
  : [];

export const APP_TEST_COUNTRIES = process.env.REACT_APP_COUNTRIES_TEST
  ? process.env.REACT_APP_COUNTRIES_TEST.split(",")
  : [];
